import { render, staticRenderFns } from "./do-priced.vue?vue&type=template&id=05401c46"
import script from "./do-priced.vue?vue&type=script&lang=js"
export * from "./do-priced.vue?vue&type=script&lang=js"
import style0 from "./do-priced.vue?vue&type=style&index=0&id=05401c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports